import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

const Home = () => {



  return (


    <div class="main_page_bg">
      <div>
        <img src="https://static.igem.wiki/teams/5334/wiki-images/main-page/block-1.png">
        </img>
        <img src="https://static.igem.wiki/teams/5334/wiki-images/main-page/block-two.png">
        </img>
        <img src="https://static.igem.wiki/teams/5334/wiki-images/main-page/block-3-world-map.png">
        </img>
        <img src="https://static.igem.wiki/teams/5334/wiki-images/main-page/block-4.png">
        </img>
        <img src="https://static.igem.wiki/teams/5334/wiki-images/main-page/block-5.jpg"></img>

        {/* <div style={{ position: 'relative', paddingTop: '56.25%' }}>
          <iframe
            title="CityU-HongKong: BevaTech - iGEM Promotional Video (2024) [English]"
            src="https://video.igem.org/videos/embed/246bce8e-f2a6-432d-976b-84349ddc946c"
            frameBorder="0"
            allowFullScreen
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            style={{ position: 'absolute', inset: '0px', width: '100%', height: '100%', border: '0' }}
          />
        </div> */}
        <div style={{ position: 'relative', paddingTop: '56.25%', margin: '20px 20px'}}>
          <iframe
            title="CityU-HongKong: Bevatech – Spot the Fake. Safeguard the Cure (2024) - Project Promotion [English]"
            width="100%"
            height="100%"
            src="https://video.igem.org/videos/embed/18cf67a1-f990-4368-bfd7-53b0897de055?subtitle=en&amp;loop=1&amp;autoplay=1&amp;warningTitle=0&amp;p2p=0"
            frameBorder="0"
            allowFullScreen
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            style={{ position: 'absolute', inset: '0' }}
          />
        </div>

        <section id="PROJECT" className="new_section">
          <h1 style={{ padding: '50px 30px 10px' }}>TO KNOW MORE ABOUT
            OUR PROJECT</h1>

          <p style={{ padding: '0px 0px 10px' }}>
           Explore the links below

          </p >

          <div className="views">
            <div className="image_div">

              <a href="https://2024.igem.wiki/cityu-hongkong/education#Science_Comic_Book" className="hover_div">
                <img src="https://static.igem.wiki/teams/5334/wiki-images/main-page/explore/page-6.png" alt="" />
                <span>
                  View Educational Comics
                </span>

              </a>
              <br />
              <a href="https://2024.igem.wiki/cityu-hongkong/education#Science_Comic_Book" className="custom_btn">
              Educational comics
              </a>
            </div>


            <div className="image_div">
              <a href="https://2024.igem.wiki/cityu-hongkong/human-practices" className="hover_div">
                <img src="https://static.igem.wiki/teams/5334/wiki-images/main-page/explore/prof-kwok.webp" alt="" />
                <span>
                  View Integrated Human Practices
                </span>

              </a>
              <br />
              <a href="https://2024.igem.wiki/cityu-hongkong/human-practices" className="custom_btn">
              Integrated Human Practices
              </a>
            </div>

            <div className="image_div">
              <a href="https://2024.igem.wiki/cityu-hongkong/education#SynBio_Boardgame" className="hover_div">
                <img src="https://static.igem.wiki/teams/5334/wiki-images/main-page/explore/board-game-bevatech.webp" alt="" />
                <span>
                  View Board game
                </span>

              </a>
              <br />
              <a href="https://2024.igem.wiki/cityu-hongkong/education#SynBio_Boardgame" className="custom_btn">
                Board game
              </a>
            </div>


            <div className="image_div">
              <a href="https://2024.igem.wiki/cityu-hongkong/model" className="hover_div">
                <img src="https://static.igem.wiki/teams/5334/wiki-images/main-page/explore/modeling.png" alt="" />
                <span>
                  View Model
                </span>

              </a>
              <br />
              <a href="https://2024.igem.wiki/cityu-hongkong/model" className="custom_btn">
                Model
              </a>
            </div>

          </div>


        </section>

        <br />
        <br />

      </div>

{/* 
      <section style={{ boxShadow: 'none' }} className="treatment  detection section">
        <h3>Cure disease - Secure generations!</h3>
      </section>
 */}




    </div>

  );
}

export default Home;

